// Ender dragon override (MOB-6 boss, M21.1). PURE (ENG-1).
//
// The dragon reuses the flying-mob primitive (circle the arena, breathe fireballs
// at the player) and advances a phase timer the host reads to report its flight
// phase. Its defining mechanic — un-killable while end crystals heal it, then a
// vulnerable perch + the dragon egg on death — is host-side (needs the crystal
// block index + the true-damage gate).
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { flying } from '../archetypes/flying';

export function enderDragon(e: Entity, def: MobDef, ctx: MobContext): void {
  e.data.phaseTimer = (e.data.phaseTimer ?? 0) + 1;
  flying(e, def, ctx); // circle the arena + breathe fireballs at the player
}
